export default __webpack_public_path__ + "static/media/titanium-solar-logo.dde9a05f.png";